"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
exports.Routes = {
    CREATE_TICKET: '/ticket',
    SEARCH_TASKS: '/support/search_tasks'
};
//# sourceMappingURL=SupportTicket.consts.js.map